import { motion } from "framer-motion";
import ShareButtons from "../../../utility/ShareButtons";
import FAQAccordion from "../../../utility/FAQAccordion";
import QuickNavigation from "../../../utility/serviceTemplateutility/QuickNavigation";
import CardDesign from "../../../utility/serviceTemplateutility/CardDesign";
import MultiStepForm from "../../../utility/serviceTemplateutility/MultiStepForm";
import WhyUs from "../../../utility/serviceTemplateutility/WhyUs";
import OurTeam from "../../homepage/OurTeam";
import Testimonials from "../../homepage/Testimonials";
import { useGlobalData } from "../../../contextApi/globalContextData";
import { useCart } from "../../../contextApi/cartContext";
import { useLanguage } from "../../../contextApi/languageContext";
import { bloodtestDubai } from "../../../text-files/homecare/bloodtest.ts";
import ListDesign from "../../../utility/serviceTemplateutility/ListDesign.jsx";

const BloodTest = () => {
  const serviceUrl = window.location.href;
  const { sectionsData } = useGlobalData();
  const { addToCart } = useCart();
  const { language } = useLanguage();
  const content = bloodtestDubai[language];
  const shared = bloodtestDubai.shared;

  return (
    <>
      <title>Blood Test at Home in Dubai - Quick, &amp; Reliable Result</title>
      <meta
        name="description"
        content="Get accurate blood test at home in Dubai. Choose from 3500+ tests, including blood and advance STD tests, with reliable lab test results delivered to your doorstep. Book now!"
      />
      <meta
        name="robots"
        content="follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
      />
      <link
        rel="canonical"
        href="https://elitebodyhome.com/services/services/blood-test-at-home-dubai/"
      />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="article" />
      <meta
        property="og:title"
        content="Blood Test at Home in Dubai - Quick, &amp; Reliable Result"
      />
      <meta
        property="og:description"
        content="Get accurate blood test at home in Dubai. Choose from 3500+ tests, including blood and advance STD tests, with reliable lab test results delivered to your doorstep. Book now!"
      />
      <meta
        property="og:url"
        content="https://elitebodyhome.com/services/blood-test-at-home-dubai/"
      />
      <meta property="og:site_name" content="elitebodyhome.com" />
      <meta property="og:updated_time" content="2025-02-15T14:01:16+00:00" />
      <meta
        property="og:image"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-70.jpg"
      />
      <meta
        property="og:image:secure_url"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-70.jpg"
      />
      <meta property="og:image:width" content="1254" />
      <meta property="og:image:height" content="700" />
      <meta property="og:image:alt" content="blood test at home" />
      <meta property="og:image:type" content="image/jpeg" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Blood Test at Home in Dubai - Quick, &amp; Reliable Result"
      />
      <meta
        name="twitter:description"
        content="Get accurate blood test at home in Dubai. Choose from 3500+ tests, including blood and advance STD tests, with reliable lab test results delivered to your doorstep. Book now!"
      />
      <meta
        name="twitter:image"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-70.jpg"
      />
      <div
        className="min-vh-100 font-sans text-dark  mb-5 mx-3"
        dir={language === "ar" ? "rtl" : "ltr"}
      >
        <div className="container-fluid px-0 py-4">
          <div className="row justify-content-center">
            <div>
              <div
                className="rounded-4 overflow-hidden shadow-sm"
                style={{ border: "2px solid #c69933" }}
              >
                <div className="row g-0 align-items-stretch">
                  {/* Image Column - Left Side */}
                  <div className="col-lg-6">
                    <img
                      loading="lazy"
                      decoding="async"
                      src={shared.images.main}
                      className="img-fluid w-100 h-100 object-fit-cover"
                      alt="Blood test Dubai | Elite Body Home"
                      style={{
                        minHeight: "400px",
                        maxHeight: "720px",
                      }}
                    />
                  </div>

                  {/* Content Column - Right Side */}
                  <div className="col-lg-6 d-flex align-items-center bg-white">
                    {language === "en" ? (
                      <div
                        className="p-4 p-md-5 w-100"
                        style={{ maxWidth: "600px", margin: "0 auto" }}
                      >
                        <h1
                          className="display-5 fw-bold mb-3"
                          style={{
                            color: "#c69933",
                          }}
                        >
                          Blood Test in Dubai
                        </h1>
                        <p className="mb-4" style={{ color: "#333" }}>
                          Experience the highest quality of homecare with our
                          reliable blood test services in Dubai. We partner with
                          CAP-accredited laboratories to ensure precise and
                          accurate results. Our team of DHA-qualified nurses
                          brings expert care right to your doorstep—anywhere in
                          Dubai—making the process safe, convenient, and
                          stress-free.
                        </p>
                      </div>
                    ) : (
                      <div
                        className="p-4 p-md-5 w-100"
                        style={{ maxWidth: "600px", margin: "0 auto" }}
                      >
                        <h1
                          className="display-5 fw-bold mb-3"
                          style={{
                            color: "#c69933",
                          }}
                        >
                          فحص الدم في دبي
                        </h1>
                        <p
                          className="mb-4"
                          style={{
                            color: "#333",
                          }}
                        >
                          اختبر أعلى مستويات الرعاية الصحية المنزلية مع خدمات
                          تحليل الدم الموثوقة في دبي. نتعاون مع مختبرات معتمدة
                          من CAP لضمان دقة وموثوقية النتائج. يزورك فريقنا من
                          الممرضين المؤهلين من هيئة الصحة بدبي (DHA) في أي مكان
                          داخل دبي لتقديم خدمة آمنة ومريحة وخالية من التوتر.
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex gap-4  w-100 ">
          <div
            className=" rounded-4 p-2 bg-white flex-grow-1 "
            style={{
              width: "65%",
              border: "2px solid #c69933",
            }}
          >
            <nav aria-label="breadcrumb" className="p-2">
              <ol className="breadcrumb">
                {content.breadcrumbs.map((item, index) => (
                  <li
                    key={index}
                    className={`breadcrumb-item ${
                      index === content.breadcrumbs.length - 1 ? "active" : ""
                    }`}
                    aria-current={
                      index === content.breadcrumbs.length - 1
                        ? "page"
                        : undefined
                    }
                  >
                    {index === content.breadcrumbs.length - 1 ? (
                      item
                    ) : (
                      <a href={index === 0 ? "/home" : "#"}>{item}</a>
                    )}
                  </li>
                ))}
              </ol>
            </nav>
            <div className="text-center my-2">
              <motion.h1
                className="display-4 fw-bold"
                style={{ color: "#c69933" }}
              >
                {content.hero.title}
              </motion.h1>

              {content.hero.subtitle && (
                <motion.h2 className="fw-semibold mt-3">
                  {content.hero.subtitle}
                </motion.h2>
              )}

              {content.hero.description && (
                <motion.p className="lead mt-3">
                  {content.hero.description}
                </motion.p>
              )}
            </div>
            <QuickNavigation />
            <section id="process" className="my-5">
              <CardDesign carditems={content.procedureSteps} />
            </section>

            {/* Benefits Section */}
            <section id="benefits" className="my-5">
              <ListDesign listitems={content.benefits} />
            </section>

            <section id="process" className="my-5">
              <ListDesign listitems={content.ingredients} />
            </section>

            {/* Eligibility Section */}
            <section id="eligibility" className="my-5">
              <CardDesign listitems={content.eligibility} />
            </section>

            {/* Preparation Section */}
            <section id="preparations" className="my-5">
              <ListDesign listitems={content.preparationTips} />
            </section>

            {/* Results Section */}
            <section id="results" className="my-5">
              <ListDesign listitems={content.results} />
            </section>

            {/* Aftercare Section */}
            <section className="my-5">
              <ListDesign listitems={content.aftercareTips} />
            </section>

            {/* Product Card */}
            {shared.images.main && (
              <motion.div
                className="my-5"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
              >
                <div
                  className="card border-0 shadow-lg rounded-4 overflow-hidden mx-auto"
                  style={{ maxWidth: "420px" }}
                >
                  <img
                    src={shared.images.main}
                    alt={content.meta.title}
                    className="card-img-top"
                    style={{ height: "280px", objectFit: "cover" }}
                  />
                  <div className="card-body text-center px-4 py-4">
                    <h5 className="card-title fw-bold text-uppercase text-dark mb-2">
                      {content.meta.title}
                    </h5>
                    <p className="card-text text-muted small">
                      {content.meta.description}
                    </p>
                    {/* <h6
                        className="text-success fw-bold mt-3"
                        style={{ fontSize: "1.1rem" }}
                      >
                        {language === "en" ? "Price" : "السعر"}: AED{" "}
                        {shared.product.price}
                      </h6> */}
                    <button
                      className="btn rounded-pill px-4 py-2 mt-3 text-white fw-bold"
                      style={{
                        background: "#c69933",
                        border: "2px solid #c69933",
                      }}
                      onClick={() =>
                        addToCart({
                          ...shared.product,
                          image: shared.images.main,
                        })
                      }
                    >
                      {language === "en" ? "Add to Cart" : "أضف إلى السلة"}
                    </button>
                  </div>
                </div>
              </motion.div>
            )}
            <WhyUs language={language} />
            <OurTeam data={sectionsData["Professional"]} />
            <Testimonials
              data={sectionsData["Success Stories"]}
              language={language}
            />
            <FAQAccordion faqData={content.faqData} />
            <ShareButtons url={serviceUrl} />
          </div>
          <MultiStepForm />
        </div>
      </div>
    </>
  );
};

export default BloodTest;
